import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'cancelBilledReading',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        effectiveDate: null,
        customerKey: '',
        customerName: '',
        propertyReference: '',
        connection: '',
        latestBilledReadingDate: '',
        reading: 0,
        consumption: 0,
        services: [],
      },
      lang: '',
      readOnly: false,
      effectiveDateView: null,
      latestBilledReadingDateView: '',

      ResultColumns: [],
      keyColumn: 'service'
    }
  },
  watch: {
    effectiveDateView: function (val) {
      this.appData.effectiveDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('cancel_billed_reading_updated', this.init);
    this.fillGridColumns();
    this.init();
  },
  methods: {
    moment: function () {
      return moment();
    },
    init() {
      Vue.nextTick(() => {
        console.log(this.dataObj);
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.readOnly = this.dataObj.readOnly;
        this.effectiveDateView = this.$options.filters.formatDateDDMMYYY(this.appData.effectiveDate);
        this.latestBilledReadingDateView = moment(this.appData.latestBilledReadingDate).format('DD/MM/YYYY');
      });
    },
    refresh() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      this.$store.state.notifier.asyncBlock(
        axios.post('/CancelBilledReadingActivity/GetData', parameter),
        response => {
          this.readOnly = response.data.readOnly;
          this.appData = response.data.item;

          this.effectiveDateView = this.$options.filters.formatDateDDMMYYY(response.data.item.effectiveDate);

          this.appData = response.data.item;
          this.readOnly = response.data.readOnly;
          this.effectiveDateView = this.$options.filters.formatDateDDMMYYY(this.appData.effectiveDate);
          this.latestBilledReadingDateView = moment(this.appData.latestBilledReadingDate).format('DD/MM/YYYY');

          this.$root.$emit('adjustment_between_customers_updated');
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //axios.post('/CancelBilledReadingActivity/GetData', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.readOnly = response.data.readOnly;
      //      this.appData = response.data.item;

      //      this.effectiveDateView = this.$options.filters.formatDateDDMMYYY(response.data.item.effectiveDate);

      //      this.appData = response.data.item;
      //      this.readOnly = response.data.readOnly;
      //      this.effectiveDateView = this.$options.filters.formatDateDDMMYYY(this.appData.effectiveDate);
      //      this.latestBilledReadingDateView = moment(this.appData.latestBilledReadingDate).format('DD/MM/YYYY');

      //      this.$root.$emit('adjustment_between_customers_updated');
      //    }

      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    fillGridColumns() {
      this.ResultColumns.push({ dataField: 'service', caption: this.$t('activities.account') });
      this.ResultColumns.push({ dataField: 'amount', caption: this.$t('activities.amount') });
      this.ResultColumns.push({ dataField: 'adjustment', caption: this.$t('activities.adjustment') });
    }
  },
}
